<template>
  <div style="padding-bottom: 30px;" v-loading="loading">
    <div
      style="padding: 6px 12px;box-sizing: border-box;background: #FFF3D9;"
      v-if="msg != ''"
    >
      <div class="message">
        <img src="https://down.baoanlailou.com/00/icon.png" alt="" />
        <div>{{ msg }}</div>
      </div>
    </div>
    <div class="topBg">
      <div class="step">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div :class="[index == active ? 'icon1' : 'icon']"></div>
          <div :class="['itemName', index == active ? 'itemName1' : '']">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">上传身份证正反面</div>
      <div class="title1">为了不影响您的接单请按要求正确上传身份证照片</div>
      <div class="loadBox">
        <div class="upload">
          <img
            src="https://down.baoanlailou.com/00/proveBg.png"
            alt=""
            class="proveBg"
          />
          <el-upload
            class="avatar-uploader"
            :on-progress="selectFile"
            :action="uploadUrl"
            :accept="'image/*'"
            :headers="deader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="imageUrl != ''" :src="imageUrl" class="proveBg1" />
            <div v-if="imageUrl == ''">
              <img
                src="https://down.baoanlailou.com/00/identity1.png"
                alt=""
                class="proveBg"
              />
              <img
                src="https://down.baoanlailou.com/00/add.png"
                alt=""
                class="add"
              />
            </div>
          </el-upload>
        </div>
        <div class="upload">
          <img
            src="https://down.baoanlailou.com/00/proveBg.png"
            alt=""
            class="proveBg"
          />
          <el-upload
            class="avatar-uploader"
            :on-progress="selectFile"
            :action="uploadUrl"
            :accept="'image/*'"
            :headers="deader"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
          >
            <img v-if="imageUrl1 != ''" :src="imageUrl1" class="proveBg1" />
            <div v-if="imageUrl1 == ''">
              <img
                src="https://down.baoanlailou.com/00/identity2.png"
                alt=""
                class="proveBg"
              />
              <img
                src="https://down.baoanlailou.com/00/add.png"
                alt=""
                class="add"
              />
            </div>
          </el-upload>
        </div>
      </div>
      <div class="btn" @click="next">保存，下一步</div>
    </div>
  </div>
</template>
<script>
import axiosUrl from "../../api/axios.js";
export default {
  data() {
    return {
      active: 2,
      list: [
        {
          name: "绑定手机号"
        },
        {
          name: "认证保安证"
        },
        {
          name: "认证身份证"
        },
        {
          name: "信息确认"
        }
      ],
      deader: {
        "x-sec-m-token": localStorage.getItem("TOKEN")
      },
      imageUrl: "",
      imageUrl1: "",
      proveData: {},
      msg: "",
      uploadUrl: "",
      loading: false
    };
  },
  mounted() {
    this.uploadUrl =
      axiosUrl.defaults.requestUrl + "mapi/api/system/file/upload";
    this.msg = localStorage.getItem("errorMsg");
    if (localStorage.getItem("errorMsg") != "") {
      this.imageUrl1 = JSON.parse(
        localStorage.getItem("baBodyguardsInfoVO")
      ).cardBackUrl;
      this.imageUrl = JSON.parse(
        localStorage.getItem("baBodyguardsInfoVO")
      ).cardFrontUrl;
    }
    if (this.$route.query.code) {
      let obj = {
        code: this.$route.query.code,
        img: this.$route.query.img
      };
      this.proveData = obj;
    }
  },
  methods: {
    selectFile() {
      this.loading = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data;
      this.loading = false;
    },
    handleAvatarSuccess1(res, file) {
      this.imageUrl1 = res.data;
      this.loading = false;
    },
    next() {
      if (this.imageUrl == "") {
        this.$message({
          message: "请上传身份证正面照",
          type: "warning"
        });
        return;
      }
      if (this.imageUrl1 == "") {
        this.$message({
          message: "请上传身份证反面照",
          type: "warning"
        });
        return;
      }
      let param = {
        cardFrontUrl: this.imageUrl,
        cardBackUrl: this.imageUrl1,
        type: 1
      };
      this.$axios
        .post(`/mapi/api/system/ocr/idcardorcompany`, param)
        .then(({ data }) => {
          let obj = {
            img: this.imageUrl,
            img1: this.imageUrl1,
            name: data.personalVO.name,
            cardCode: data.personalVO.cardCode,
            sex: data.personalVO.sex
          };
          this.$router.push({
            path: "/confirm",
            query: {
              proveData: this.proveData,
              identity: obj
            }
          });
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style scoped>
.loadBox {
  display: flex;
  justify-content: space-between;
}
.topBg {
  width: 100%;
  background-image: url("https://down.baoanlailou.com/00/bg1.png");
  background-size: 100% 100%;
  padding: 13px 10px;
  box-sizing: border-box;
}
.step {
  width: 100%;
  padding: 16px 8px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(58, 103, 133, 0.11);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
}
.item {
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
  position: relative;
}
.icon {
  width: 8px;
  height: 8px;
  background: #ccd9e9;
  border-radius: 4px;
  margin: 0 auto 10px;
}
.item::after {
  content: "";
  width: 85px;
  height: 1px;
  background: #ccd9e9;
  position: absolute;
  top: 4px;
  left: 40px;
}
.step :last-child::after {
  display: none;
}
.icon1 {
  width: 8px;
  height: 8px;
  border: 1px solid #02b6fc;
  border-radius: 4px;
  margin: 0 auto 10px;
  box-sizing: border-box;
}
.itemName {
  font-size: 12px;
  font-weight: 400;
  color: #94a4b7;
  line-height: 16px;
}
.itemName1 {
  color: #02b6fc;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #111111;
  line-height: 22px;
}
.phone {
  width: 100%;
  height: 50px;
  background: #f8f9fb;
  margin-top: 15px;
  border-radius: 10px;
  overflow: hidden;
}
.message {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff6f23;
  line-height: 14px;
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.message img {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}

.box {
  padding: 0 20px;
  box-sizing: border-box;
}
.title1 {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
  line-height: 16px;
  margin-top: 6px;
}
.upload {
  width: 162px;
  height: 102px;
  background: #ecf4ff;
  border-radius: 10px;
  border: 1px solid rgba(163, 202, 255, 0.47);
  position: relative;
  margin-top: 15px;
  overflow: hidden;
}
.proveBg {
  display: block;
  width: 100px;
  height: 58px;
  position: absolute;
  top: 22px;
  left: 20%;
}
.proveBg1 {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.add {
  display: block;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 37px;
  left: 43%;
}
.btn {
  width: 100%;
  height: 44px;
  background: #02b6fc;
  border-radius: 22px;
  margin-top: 88px;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
}
</style>
<style>
.el-input {
  width: 100%;
  height: 100% !important;
}
.el-input__inner {
  height: 100% !important;
  background: transparent !important;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 50px;
  padding: 15px 12px;
  box-sizing: border-box;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/identity/identity.vue